"use client";

import { useState } from "react";

import { Button, Icon, View } from "@/components";
import useDropdown from "@/hooks/useDropdown";

export type SwitchLanguageProps = {
  isWhite?: boolean;
};

const languages = ["English", "Arabic", "Bangla", "Spanish"];
const SwitchLanguage = ({ isWhite }: SwitchLanguageProps) => {
  const { open, ref, toggleOpen } = useDropdown();
  const [selected, setSelected] = useState(languages[0]);

  return (
    <View className="relative" ref={ref}>
      <Button
        aria-label="Switch Language"
        action={toggleOpen}
        className={`flex gap-1 p-2 sm:p-3 rounded-full ${
          isWhite
            ? "bg-n0 dark:bg-bg4 border border-n30 dark:border-n500"
            : "bg-primary/5 dark:bg-bg3"
        }`}
      >
        <Icon name="earth-americas" />
        <Icon name="chevron-down" />
      </Button>
      <View
        className={`bg-n0 border dark:border-n500 ltr:origin-top-right rtl:origin-top-left dark:bg-n800 rounded-md ltr:right-0 rtl:left-0 shadow-lg absolute top-full transition-all duration-300 ${
          open ? "opacity-100 scale-100 visible" : "opacity-0 scale-0 invisible"
        }`}
      >
        <View
          type="ul"
          className="flex flex-col w-32 bg-n0 p-1 rounded-md dark:bg-bg4"
        >
          {languages.map((lang) => (
            <View type="li" key={lang}>
              <Button
                aria-label={`Switch to ${lang}`}
                type="button"
                action={() => {
                  setSelected(lang);
                  toggleOpen();
                }}
                className={`w-full text-left px-4 block py-2 rounded-md cursor-pointer transition duration-300 hover:text-primary focus:outline-none focus:bg-primary/10 ${
                  selected === lang ? "bg-primary text-n0 hover:!text-n0" : ""
                }`}
              >
                {lang}
              </Button>
            </View>
          ))}
        </View>
      </View>
    </View>
  );
};

export default SwitchLanguage;
